const lang = {
  items: "Items",
  add_item: "Add Item",
  add_new_item: "ፋስፍስድፍ",
  edit_item: "Edit Item",
  category_list: "Category List",
  item_list: "የእቃዎች ዝርዝር",
  warehouse_list: "የመጋዝንዎች ዝርዝር",
  add_new: "Add New",
  add_warehouse: "Add Warehouse",
  edit_warehouse: "Edit Warehouse",
  add_brand: "Add Brand",
  edit_brand: "Edit Brand",
  brand_list: "Brands List",
};
module.exports = lang;
